<div class="select-file-sequence">
  <p-dropdown
    [options]="getOptions()"
    [(ngModel)]="fileSequenceSelectedOption"
    optionLabel="name"
    placeholder="Choose a file sequence"
    class="dropdown-width"
  />
  <p-button
    label="Assign"
    [disabled]="!fileSequenceSelectedOption"
    (onClick)="startFileSequence(fileSequenceSelectedOption)"
  />
</div>
